import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./MenuModal.css";
import AlertModal from "./AlertModal";
import { getHelpVideoMap } from "../../Common/HelpVideoMap";

const MenuModal = (props) => {
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const [AlertModalVideoKey, setAlertModalVideoKey] = useState(undefined);
  const listRef = useRef(null);

  // TEMP QA aid — flags which "i" buttons resolve to a real video, so
  // videoKey coverage can be eyeballed directly in the running menu instead
  // of cross-referencing code. Safe to delete: this state, the fetch below,
  // and the "mm-item-info-has-video" class + its CSS rule in MenuModal.css.
  const [videoMap, setVideoMap] = useState({});
  useEffect(() => {
    if (props.show) getHelpVideoMap().then(setVideoMap).catch(() => {});
  }, [props.show]);

  useEffect(() => {
    if (props.show && listRef.current) {
      listRef.current.scrollTop = 0;
    }
  }, [props.show, props.menu_modal_list]);

  const handleClose = () => props.onHide();

  const handleMethod = (menu_item) => {
    props.onHide();
    if (menu_item.method !== null) menu_item.method(menu_item.label);
  };

  const myAlert = (message, title, buttons, videoKey) => {
    setAlertModalMessage(message);
    setAlertModalTitle(title == null ? "Message" : title);
    setAlertModalButtons(buttons == null ? [{ Title: "OK", Method: null }] : buttons);
    setAlertModalVideoKey(videoKey);
    setAlertModalShow(true);
  };

  const displayMenuInfo = (menu_item) => myAlert(menu_item.info, "Info", null, menu_item.videoKey);

  // Support both the correct prop name and the legacy typo variant
  const headerImage = props.menu_modal_image || props.menu_model_image;

  if (AlertModalShow)
    return (
      <AlertModal
        show={AlertModalShow}
        onHide={() => setAlertModalShow(false)}
        attributes={{
          onHide: () => setAlertModalShow(false),
          AlertModalTitle: AlertModalTitle,
          AlertModalMessage: AlertModalMessage,
          AlertModalButtons: AlertModalButtons,
          videoKey: AlertModalVideoKey,
        }}
      />
    );

  return (
    <div className="modal">
      <Modal
        show={props.show}
        onHide={handleClose}
        animation={false}
        dialogClassName="myModalClass mm-dialog"
        aria-labelledby="mm-title"
        centered
        scrollable={false}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="mm-shell">
            {/* Header */}
            <div className="mm-header">
              {props.onBack ? (
                <button className="mm-back" onClick={props.onBack} aria-label="Back">
                  {"<"}
                </button>
              ) : (
                <div className="mm-back-placeholder" />
              )}
              {headerImage && (
                <div className="mm-header-icon">{headerImage}</div>
              )}
              <h2 className="mm-title" id="mm-title">
                {props.menu_modal_heading}
              </h2>
              <button className="mm-close" onClick={props.onHide} aria-label="Close">
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>

            {/* Item list */}
            <div className="mm-list" ref={listRef}>
              {props.menu_modal_list.map((menu_item, i) => {
                if (menu_item.label === "**SEPARATOR***") {
                  return <div key={`sep${i}`} className="mm-separator" />;
                }
                if (!menu_item.visible) return null;
                return (
                  <div
                    key={`item${i}`}
                    className={`mm-item${menu_item.highlight ? " mm-item-highlight" : ""}`}
                    style={{ "--i": i }}
                    onClick={() => handleMethod(menu_item)}
                  >
                    {/* {menu_item.icon ? (
                      <span className="mm-item-icon">{menu_item.icon}</span>
                    ) : (
                      <span className="mm-item-dot" />
                    )} */}
                    <span className="mm-item-label">
                      <span className="mm-item-check">
                        {typeof menu_item.checked !== "undefined" &&
                        (typeof menu_item.checked === "function" ? menu_item.checked() : menu_item.checked) ? (
                          <FontAwesomeIcon icon={solid("check")} />
                        ) : null}
                      </span>
                      {menu_item.label}
                    </span>
                    {typeof menu_item.info !== "undefined" && (
                      <button
                        className={`mm-item-info${menu_item.videoKey && videoMap[menu_item.videoKey] ? " mm-item-info-has-video" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          displayMenuInfo(menu_item);
                        }}
                        aria-label={`Info: ${menu_item.label}`}
                      >
                        <FontAwesomeIcon icon={solid("info")} />
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MenuModal;
